export default "__VITE_ASSET__DNYGuaoS__"